import http from '../_http'

const payment = {
  //default
  summaryPayment: (m) => { return http.get(`manager/billing/payment`, m); },
  listPayment: (m) => { return http.post(`manager/billing/payment/list`, m); },
  detailPayment: (m) => { return http.get(`manager/billing/payment/${m.id}`); },

  //crud
  insertPayment: (m) => { return http.post(`manager/billing/payment`, m); },
  updatePayment: (m) => { return http.put(`manager/billing/payment`, m); },
  deletePayment: (m) => { return http.delete(`manager/billing/payment/${m.id}`); },
}

export default payment

export { payment }